module.exports = __webpack_public_path__ + "static/media/icon_52.0f1a2139.svg";